/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type APIResponseBase,
    APIResponseBaseFromJSON,
    APIResponseBaseToJSON,
} from '../models/APIResponseBase';
import {
    type GetOrganizationsTeam200Response,
    GetOrganizationsTeam200ResponseFromJSON,
    GetOrganizationsTeam200ResponseToJSON,
} from '../models/GetOrganizationsTeam200Response';

export interface GetOrganizationsTeamRequest {
    slashIDOrgID: string;
}

/**
 * 
 */
export class OrganizationsApi extends runtime.BaseAPI {

    /**
     * Creates request options for getOrganizationsTeam without sending the request
     */
    async getOrganizationsTeamRequestOpts(requestParameters: GetOrganizationsTeamRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['slashIDOrgID'] == null) {
            throw new runtime.RequiredError(
                'slashIDOrgID',
                'Required parameter "slashIDOrgID" was null or undefined when calling getOrganizationsTeam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['slashIDOrgID'] != null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/organizations/team`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve a list of all the team members of your organization.
     * List organization team members
     */
    async getOrganizationsTeamRaw(requestParameters: GetOrganizationsTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOrganizationsTeam200Response>> {
        const requestOptions = await this.getOrganizationsTeamRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetOrganizationsTeam200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve a list of all the team members of your organization.
     * List organization team members
     */
    async getOrganizationsTeam(requestParameters: GetOrganizationsTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOrganizationsTeam200Response> {
        const response = await this.getOrganizationsTeamRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
